import React, { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import './modal.css'; // ملف CSS لتنسيق الأزرار

const VideoPlayer = () => {
    const playerRef = useRef(null); // مرجع لتفاعل مع ReactPlayer
    const [playing, setPlaying] = useState(false); // حالة تشغيل الفيديو

    const handlePlayPause = () => {
        setPlaying(!playing);
    };

    const handleVolumeChange = (event) => {
        const volume = parseFloat(event.target.value);
        if (playerRef.current) {
            playerRef.current.seekTo(playerRef.current.getCurrentTime(), 'seconds');
        }
    };

    return (
        <div className="video-container">
            <ReactPlayer
                ref={playerRef}
                url=""
                playing={playing}
                controls={false} // إخفاء عناصر التحكم الافتراضية
                width="100%"
                style={{height:"100%"}}
            />
            <div className="controls">
                <button onClick={handlePlayPause}>
                    {playing ? 'Pause' : 'Play'}
                </button>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    onChange={handleVolumeChange}
                    defaultValue={0.8}
                />
            </div>
        </div>
    );
};

export default VideoPlayer;
